/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const blackBlue = {
    50: '#FDFDFF',
    100: '#F9F9FF',
    200: '#E9E9F5',
    300: '#D8D9EB',
    400: '#BABDD4',
    500: '#9FA1BB',
    600: '#8487A1',
    700: '#5E607E',
    800: '#3A3C4D',
    900: '#262838',
    1000: '#171822',
};
